import React, { useState } from "react";
import "./CustomerCareCard.scss";
import copyFunction from "../../../../../util/function/copyFunction";
import {
    Skeleton,
    Modal,
    Stack,
    Typography,
    Chip,
    Tabs,
    Tab,
    Divider,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCustomerCareData } from "../../../../../features/claims/claimSlice";
import { setOperationTeamData } from "../../../../../features/claims/claimSliceOperationTeam";
import Box from "@mui/material/Box";
import { useQuery } from "react-query";
import { claimsService } from "../../../../../services/api/claimService";
import { useStateValue } from "../../../../../util/stateProvider";
const CopyIcon =
    "https://imtbepublic.s3.ap-south-1.amazonaws.com/oldAssets/assets/images/icons/general/copy.svg";
const CloseIcon =
    "https://imtbepublic.s3.ap-south-1.amazonaws.com/oldAssets/assets/images/icons/Modals_icons/Close.svg";
const CustomerCareCard = (props) => {
    const [{ user }] = useStateValue();
    const reducerDispatch = useDispatch();
    const customerCareData = useSelector((state) =>
        props.type === "OperationTeam"
            ? state.operationTeam.operationTeamData
            : state.customerCare.customerCareData
    );
    // const operationTeamData = useSelector(
    //     (state) => state.operationTeam.operationTeamData
    // );
    const [open, setOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        { label: "Broker", key: "Broker" },
        { label: "TPA", key: "Tpa" },
        { label: "Insurer", key: "Insurer" },
    ];

    const getAvailableTabs = () => {
        if (!customerCareData?.detailedEscalationMatrixDTOS) return [];
        return tabs.filter((tab) => {
            const tabKey = tab.key;
            const contacts =
                customerCareData.detailedEscalationMatrixDTOS?.[tabKey] || [];
            return contacts.some(
                (contact) => contact.name && contact.name.trim() !== ""
            );
        });
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const getCurrentTabData = () => {
        if (!customerCareData?.detailedEscalationMatrixDTOS) return [];
        const availableTabs = getAvailableTabs();
        if (availableTabs.length === 0) return [];

        const currentTab = availableTabs[activeTab];
        if (!currentTab) return [];

        const tabKey = currentTab.key;
        const contacts =
            customerCareData.detailedEscalationMatrixDTOS?.[tabKey] || [];
        return contacts.filter(
            (contact) => contact.name && contact.name.trim() !== ""
        );
    };

    const renderContactCard = (contact, index) => (
        <Box
            key={index}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
                width: "100%",
                gap: "8px",
                marginBottom: "16px",
            }}
        >
            <Stack
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
            >
                <Typography variant="subtitle2">{contact.name}</Typography>
                <Chip
                    label={
                        <Typography
                            variant="body2"
                            sx={{
                                color:
                                    contact.level === "1"
                                        ? "#d32f2f"
                                        : contact.level === "2"
                                        ? "#ed6c02"
                                        : "#2e7d32",
                            }}
                        >
                            {`Level ${contact.level}`}
                        </Typography>
                    }
                    sx={{
                        height: "18px",
                        width: "fit-content",
                        backgroundColor:
                            contact.level === "1"
                                ? "#ffebee"
                                : contact.level === "2"
                                ? "#fff3e0"
                                : "#e8f5e8",
                    }}
                />
            </Stack>
            {[...contact.phone.split(","), ...contact.email.split(",")]
                .filter((contactInfo) => contactInfo.trim() !== "")
                .map((contactInfo, contactIndex) => (
                    <Stack
                        key={contactIndex}
                        flexDirection={"row"}
                        gap={"8px"}
                        alignItems={"center"}
                    >
                        <Box
                            sx={{
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src={CopyIcon}
                                alt=""
                                style={{
                                    cursor: "pointer",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onClick={() => {
                                    copyFunction(contactInfo.trim());
                                }}
                            />
                        </Box>
                        <Typography variant="body2" color="textPrimary">
                            {contactInfo.trim()}
                        </Typography>
                    </Stack>
                ))}
        </Box>
    );

    useQuery(
        ["customerCareClaimContact"],
        () => claimsService.employer.getClaimContact(),
        {
            enabled: !!user && props.type !== "OperationTeam",
            onSuccess: (data) => {
                reducerDispatch(setCustomerCareData(data));
            },
        }
    );

    useQuery(
        ["customerCareOperationsContact"],
        () => claimsService.employer.getOperationContact(),
        {
            enabled:
                !!user &&
                user.userType.toLowerCase() !== "employee" &&
                props.type === "OperationTeam" &&
                !customerCareData,
            onSuccess: (data) => {
                reducerDispatch(setOperationTeamData(data));
            },
        }
    );

    if (!customerCareData?.phone && !customerCareData?.email) {
        return null;
    }

    return (
        <div
            className={`customerCare ${
                props?.classname ? props.classname : ""
            }`}
            style={props?.style ? props.style : {}}
        >
            <div className="customerCare__container">
                <h2 className="heading">
                    {props.type === "OperationTeam"
                        ? "Operations Team"
                        : "Claim Assistance"}
                </h2>

                <div className="text">
                    {customerCareData?.name ? (
                        <h1>{customerCareData?.name}</h1>
                    ) : (
                        <Skeleton variant="text" width="40%" height={32} />
                    )}
                </div>
                <div className="text">
                    <div>
                        <p>Phone no.</p>
                        {customerCareData?.phone ? (
                            <h3>{customerCareData?.phone}</h3>
                        ) : (
                            <Skeleton variant="text" width={80} height={17} />
                        )}
                    </div>
                    <img
                        src={CopyIcon}
                        alt=""
                        className="pointer"
                        onClick={() => {
                            copyFunction(customerCareData?.phone);
                        }}
                    />
                </div>
                <div className="text">
                    <div>
                        <p>Email</p>
                        {customerCareData?.email ? (
                            <h3>{customerCareData?.email}</h3>
                        ) : (
                            <Skeleton variant="text" width={80} height={17} />
                        )}
                    </div>
                    <img
                        src={CopyIcon}
                        alt=""
                        className="pointer"
                        onClick={() => {
                            // setOpen(true);
                            copyFunction(customerCareData?.email);
                        }}
                    />
                </div>
                {customerCareData?.detailedEscalationMatrixDTOS &&
                    Object.values(
                        customerCareData.detailedEscalationMatrixDTOS
                    ).some(
                        (category) =>
                            Array.isArray(category) &&
                            category.some(
                                (contact) =>
                                    contact.name && contact.name.trim() !== ""
                            )
                    ) && (
                        <button
                            style={{
                                color: "red",
                                cursor: "pointer",
                                border: "none",
                                background: "none",
                                textDecoration: "underline",
                                fontSize: "12px",
                                padding: 0,
                            }}
                            onClick={() => setOpen(true)}
                            className="fontSize_12"
                        >
                            Not able to Connect?
                        </button>
                    )}
            </div>
            {open && (
                <Modal
                    open={open}
                    onClose={() => {
                        setOpen(false);
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            borderRadius: 3,
                            border: "background.paper",
                            outline: "none",
                            p: 2,
                            width: {
                                xs: "350px",
                                sm: "400px",
                                md: "500px",
                                lg: "500px",
                                xl: "500px",
                            },
                            overflowX: "auto",
                        }}
                    >
                        <div className="d-flex justify-content-between pt8 pb8">
                            <Typography variant="h6" className="title">
                                {props.type === "OperationTeam"
                                    ? "Operations Team matrix"
                                    : "Claim escalation"}
                            </Typography>
                            <div
                                className="close"
                                onClick={() => setOpen(false)}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={CloseIcon}
                                    className="mb8"
                                    alt="close"
                                />
                            </div>
                        </div>

                        <Divider sx={{ width: "100%", mb: 2 }} />

                        {getAvailableTabs().length > 0 && (
                            <Box
                                sx={{
                                    width: "100%",
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    mb: 2,
                                }}
                            >
                                <Tabs
                                    value={activeTab}
                                    onChange={handleTabChange}
                                    variant="fullWidth"
                                >
                                    {getAvailableTabs().map((tab, index) => (
                                        <Tab key={tab.key} label={tab.label} />
                                    ))}
                                </Tabs>
                            </Box>
                        )}

                        <Box
                            sx={{
                                width: "100%",
                                maxHeight: "60vh",
                                overflowY: "auto",
                                paddingTop: "8px",
                            }}
                        >
                            {getCurrentTabData().map((contact, index) =>
                                renderContactCard(contact, index)
                            )}
                        </Box>

                        <div className="pt10 fontSize_12">
                            <span style={{ fontWeight: 600, color: "black" }}>
                                Please note:
                            </span>{" "}
                            Please follow the given hierarchy only!
                        </div>
                    </Box>
                </Modal>

                // </Modal>
            )}
        </div>
    );
};

export default CustomerCareCard;
